// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";

import { Button as MuiButton } from "@mui/material";

import href from "../util/href";

/**
 * Our Button adds the `rel="noopener"` attribute if this button is an `href`.
 * External links should always use `noopener`; internal links can override `rel`
 * if required.
 *
 * There are no other differences from MaterialUI.
 *
 * @see https://web.dev/external-anchors-use-rel-noopener/
 * @see https://material-ui.com/api/Button/
 */

const Button = (props) => {
  return (
    <MuiButton
      rel={props.href ? "noopener" : undefined}
      {...props}
      href={props.href ? href.sanitize(props.href) : undefined}
    />
  );
};

export default Button;
